import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './App'
import { ProveedorSesion } from './auth/sesion'
import { ErrorBoundary } from './componentes/ErrorBoundary'
import { ErrorApi } from './api/cliente'
import './index.css'

/**
 * Cliente de consultas, uno para toda la aplicación.
 *
 * El reintento automático se acota: un 4xx no se arregla repitiendo la
 * petición. Reintentar un 401, un 403 de cuenta suspendida o un 404 solo
 * multiplica la carga y retrasa el mensaje que la persona necesita leer. Un
 * fallo de red o un 5xx sí se reintenta, una vez.
 */
const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (intentos, error) => {
        if (error instanceof ErrorApi && error.estado >= 400 && error.estado < 500) return false
        return intentos < 1
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    // Una escritura NUNCA se reintenta sola: podría emitir dos órdenes.
    mutations: { retry: false },
  },
})

const raiz = document.getElementById('root')
if (!raiz) throw new Error('Falta #root en index.html')

createRoot(raiz).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      {/* El límite de error envuelve también al proveedor de sesión: si la
          sesión revienta al montar, hay que ver un mensaje y no una pantalla
          en blanco, que es lo que hacía la v1. */}
      <ErrorBoundary>
        <ProveedorSesion>
          <App />
        </ProveedorSesion>
      </ErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
)
